var React = require('react');

function InputArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 12h15m0 0-6.75-6.75M19.5 12l-6.75 6.75","stroke":"#9ca3af","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

InputArrowRight.defaultProps = {"fill":"none","height":"24","width":"24"};

module.exports = InputArrowRight;

InputArrowRight.default = InputArrowRight;
